<template>
	<div class="agreementPage">
		<div v-show="!esignShow">
			<div class="scroll-container">
				<div class="scroll-content">
					<div class="signContext">
						<div class="word-title word-strong">理赔直付服务授权委托书</div>

						<p style="text-indent: 0em">授权人(被保险人)姓名：<span class="underline">{{ fullName }}</span></p>
						<p>本人授权委托<span class="underline">中国人寿保险股份有限公司广州市分公司</span>服务商：广州医智付健康科技有限公司(以下简称"医智付")作为本次门诊、治疗、检查或购药等项目的理赔直付服务的机构。在本人使用理赔直付功能时，由医智付先行垫付理赔金并预先交付相应的服务或药品，后续再由医智付代为向保险公司提出理赔申请，理赔款由保险公司直接支付给医智付。</p>
						
						<p>在医智付使用理赔直付过程中，如理赔款项不足以全额支付本人在服务机构的所有费用，超额部分需由本人与医智付自行结算。</p>
						
						<p>保险公司、医智付应遵守现行的关于个人信息、数据及隐私保护的法律法规，以确保个人信息得到保护，并采取充分的技术手段和制度管理，保护我提供给贵司的个人信息，数据和隐私不受到非法的泄露或披露给未获授权的第三方。</p>
						
						<div class="section-title">授权声明</div>
						<p>1、本人声明以上理赔申请及陈述均为事实，并无重大遗留，可作为保险公司理赔依据；</p>
						<p>2、办理以上理赔事务过程中，受托机构所作的相应文书及签字皆代表本人的真实意思表示；</p>
						<p>3、本人此次医疗费用按合同约定责任理算后的赔款金额，在直付结算时由医智付先行为我垫付，并同意<span class="underline">中国人寿保险股份有限公司广州市分公司</span>将理赔款汇至医智付指定账户。</p>
						
						<p>受委托人：广州医智付健康科技有限公司</p>
						<p>委托人：<img :src="resultImg" class="signImg" v-if="resultImg"/></p>					
					</div>
				</div>
			</div>
			<div><van-checkbox v-model="checked" shape="square">本人已知晓并同意上述说明</van-checkbox></div>
			<div>
				<div class="box-btn"><van-button  size="large" type="info" @click="esignShow = true">{{resultImg ? '已签名' : '请签名'}}</van-button></div>
				<div class="box-btn"><van-button :disabled="!resultImg || !checked"  size="large" type="info" @click="preSubmit">提交</van-button></div>
			</div>
		</div>
		<div v-show="esignShow">
			<div class="box-esign">
				<div class="esignTip">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;请横屏签名</div>
				<vue-esign ref="esign" direction="left" :width="padWidth" :height="padHeight"  :isCrop="isCrop" :lineWidth="6" :willReadFrequency="willReadFrequency" lineColor="#000" :bgColor.sync="bgColor" />
			</div>
			<div class="box-esignBtn">
				<div class="esignBtn"><van-button  size="large"   @click="handleCancel" >取消</van-button></div>
				<div class="esignBtn"><van-button  size="large" type="warning"  @click="handleReset" >重新签名</van-button></div>
				<div class="esignBtn"><van-button type="info"  size="large"  @click="handleGenerate" >确定签名</van-button></div>
			</div>
		
		</div>
	</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import vueEsign from 'vue-esign'

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
	vueEsign
  },
  data() {
    return {
		checked: false,//同意书确认
		willReadFrequency: true,
		bgColor: '',
		resultImg: '',
		isCrop: false,
		esignShow: false,//签字框
		padWidth: document.body.clientWidth - 12,
      	padHeight:  window.innerHeight * 80 / 100 ,
		fullName: `${sessionStorage.getItem('cstFullName')}`,
	};
  },
  methods: {
	preSubmit(){
		//1）成pdf
		//2）保存
		let lysCstUserId = sessionStorage.getItem('lysCstUserId');

		if(this.resultImg && lysCstUserId)
			this.createSignPdf();
		else{
			this.$toast('请先签名');
		}
	},

	doSubmit(authPdfPath,authImgPath){
		let data = {
			lysCstUserId: `${sessionStorage.getItem('lysCstUserId')}`,
    		signUrl: this.resultImg,
			authPdfPath: authPdfPath,
			authImgPath: authImgPath,
		};
		
		this.$getRequestData20('saveUserGrant20', data)
		.then(result => {
			let { grantFlag } = result.bizData
			if( grantFlag == 'y'){
				this.$router.push({ path: '/index/homePage' })
			}
		})
	},

	handleReset () {
		this.$refs.esign.reset()
		this.resultImg = ''
	},

	handleCancel(){
		this.esignShow = false;
	},

	handleGenerate () {
		this.$refs.esign.generate()// 使用生成器调用把签字的图片转换成为base64图片格式
		.then(res => {
			this.resultImg = res
			console.log(this.resultImg)
		}).catch(err => {
			console.log(err)
			this.$toast('请签名') // 画布没有签字时会执行这里 'Not Signned'
		})
		this.esignShow = false
	},

	createSignPdf(){

		let reqData={
			fullName:this.fullName,
			signStr:this.resultImg,
		};
            this.$getRequestNotGateWay('cup/pdf/createPDFMgt/yzfPdf', reqData)
            .then(result =>{

                if (result.resultCode == '0000') { //不是 0000 均为失败
                    let bizDataJson = (result.bizData);
                    
                   this.doSubmit(bizDataJson.pdfPath,bizDataJson.imgPath);
                
                } else {
                    this.$toast.fail(result.msg);
                }

            })
            .catch(err => {
              console.log(err);
              this.$toast.fail(err);
              
            }) 		
	
		/*
			let requestDataJson={};
		jquery.ajax({
				url: "http://msdev.ebao51.cn/cup/pdf/createPDFMgt/didiPDF",//发送请求的地址
				type: 'POST', //请求方法(post或者get)，默认是get，要求是String类型的参数。其他的htpp请求如（put、delete）等也支持，但是要浏览器支持
				data: JSON.stringify(requestDataJson), //发送到服务器的数据，要求是Object或string类型的参数。
				dataType: 'json',//用于指定服务器返回的数据类型，要求为String类型的参数。xml、html、script、json、jsonp、text
				async: true, //true为异步默认值 false同步
				success: (responseData) => {
					console.log(responseData);
					if (responseData.resultCode == '0000') {
						let dataJson = JSON.parse(responseData.bizData); //解析当前数据
						
						console.log('申请书PDF:');
						console.log(dataJson);
						
					} else {
						this.$toast.fail(responseData.errMsg);
						
					}
				}, //请求成功
				error: (err) => {
					this.$toast.fail(err);
					
				} //请求失败
		}); */
	},
  },
 
};

</script>

<style lang="less" scoped>
//@import url(); 引入公共css类
.agreementPage {
	padding: 0 12px;
	.scroll-container {
		width: 100%;
		height: 65vh; /* 设置容器的高度 */
		overflow: auto; /* 开启容器的滚动 */
		border: 1px solid;
		margin: 20px 0;
		.scroll-content {
			width: 100%;
			text-align: left;
		}
	}
	.box-btn {
		padding: 12px 10%;
	}
	.box-esign{
		margin-bottom: 40px;
	}
	.box-esignBtn{
		display: flex;
		justify-content: space-between;
		.esignBtn{
			width: 20%;

		}
	}
	canvas[data-v-7d9055bc] {
		border: 1px solid #000;
	}
	.esignTip{
		transform: rotate(90deg);
		display: inline-block;
		position: absolute;
		top: 6vw;
		right: 0vw;
		color: #000;
	}

    .signContext {
        text-indent: 2em;
        line-height: 30px;
        font-size: 15px;
		margin: 1.5em 0.5em;
    }

    .word-title{
        text-align: center;
        text-indent: 0;
    } 
    .word-strong {
        font-weight: 600;
    }
    .word-right {
        text-align: right;
    }
	
	.underline {
		border-bottom: 1px solid #646566;
		display: inline-block;
		min-width: 120px;
		padding: 0 5px;
		margin: 0 2px;
		color: red;
		text-indent: 0em;
	}
	.section-title {
		font-weight: bold;
		margin: 16px 0 8px;
		color: #323233;
		font-size: 15px;
	}

	.signImg{
		transform: rotate(-90deg);
   		height: 90px;
    	vertical-align: middle;
    	/* padding-left: 0px; */
    	margin-left: 15px;
	}

	.box-esignBtn .esignBtn {
		width: 20%;
		transform: rotate(
			90deg
		);
	}
}


</style>
